module.exports = "<div class=\"container-fluid edit-component\">\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <h3>\n                <i class=\"fas fa-envelope-open text-warning\"></i>\n                Edit message overview\n            </h3>\n            <hr class=\"mt-0\"/>\n            <loading *ngIf=\"isLoading\" [loadingMessage]=\"'Loading...'\"></loading>\n        </div>\n    </div>\n    <messages *ngIf=\"!isLoading\" [messageCollection]=\"messageCollection\" [settings]=\"settings\" (done)=\"done()\"></messages>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/edit.component.html
// module id = 605
// module chunks = 1